import { Box, Grid, Skeleton, FormControl, InputLabel, Select, MenuItem, TextField, Paper } from "@mui/material";

const NotificationRulesSkeleton = () => {
    return (
        <Box
            sx={{
                boxShadow:
                    "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
                margin: "10px",
                backgroundColor: "#fff",
                borderRadius: 1,
                mx:3
            }}
        >
            <Box sx={{ p: 3 }}>
                <Box sx={{ display: "flex", flexWrap: "nowwrap", gap: "10px", alignItems: "center" }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={3}>
                            <Skeleton variant="rectangular" width="100%" height={35}  sx={{ borderRadius: 1 }} />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <Skeleton variant="rectangular" width="100%" height={35} sx={{ borderRadius: 1 }} />
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </Box>
    );
};

export default NotificationRulesSkeleton;
